import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, InstagramIcon } from './icons/Icons';
import { Logo } from './Logo';
import { useLanguage } from '../LanguageContext';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    language,
    toggleLanguage
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: language === 'es' ? 'Inicio' : 'Home',
    href: '#inicio'
  }, {
    name: language === 'es' ? 'Sobre María Fernanda' : 'About María Fernanda',
    href: '#sobre-mi'
  }, {
    name: language === 'es' ? 'Servicios' : 'Services',
    href: '#servicios'
  }, {
    name: language === 'es' ? 'Por Qué Skin Glow Studio22' : 'Why Skin Glow Studio22',
    href: '#por-que'
  }, {
    name: language === 'es' ? 'Testimonios' : 'Testimonials',
    href: '#testimonios'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: language === 'es' ? 'Contacto' : 'Contact',
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-brand-ivory ${isScrolled ? 'shadow-sm py-2' : 'py-3'}`} data-id="element-182">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-183">
        <a href="#inicio" className="block" data-id="element-184">
          <Logo size="md" data-id="element-185" />
        </a>

        {/* Actions — hamburger menu at all breakpoints */}
        <div className="flex items-center space-x-4 relative z-50" data-id="element-186">
          <button type="button" onClick={toggleLanguage} aria-label="Toggle language" className="flex items-center gap-1 text-xs font-semibold tracking-widest text-brand-charcoal border border-brand-gold/30 rounded-full px-3 py-1.5 hover:border-brand-gold transition-colors" data-id="element-187">
            <span className={language === 'es' ? 'text-brand-gold' : 'opacity-50'} data-id="element-188">
              ES
            </span>
            <span className="opacity-30" data-id="element-189">|</span>
            <span className={language === 'en' ? 'text-brand-gold' : 'opacity-50'} data-id="element-190">
              EN
            </span>
          </button>
          <a href="https://instagram.com/skinglowstudio22" target="_blank" rel="noopener noreferrer" className="text-brand-charcoal hover:text-brand-gold transition-colors" aria-label="Instagram" data-id="element-191">
            <InstagramIcon size={22} data-id="element-192" />
          </a>
          <button className="text-brand-charcoal" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle Menu" data-id="element-193">
            {isMobileMenuOpen ? <XIcon size={28} data-id="element-194" /> : <MenuIcon size={28} data-id="element-195" />}
          </button>
        </div>
      </div>

      {/* Menu Drawer */}
      <AnimatePresence data-id="element-196">
        {isMobileMenuOpen && <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'tween',
        duration: 0.3
      }} className="fixed inset-0 bg-brand-ivory z-40 flex flex-col pt-28 px-6 pb-8 h-screen overflow-y-auto md:left-auto md:right-0 md:w-[420px] md:shadow-2xl" data-id="element-197">
            <nav className="flex flex-col space-y-6 text-center mt-8" data-id="element-198">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-2xl font-serif text-brand-charcoal hover:text-brand-gold transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-199">
                  {link.name}
                </a>)}
              <div className="pt-8 flex flex-col items-center space-y-6" data-id="element-200">
                <a href="https://wa.me/12679841013" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)} className="w-full max-w-xs py-3 bg-brand-gold text-white text-lg font-medium rounded-full hover:bg-brand-bronze transition-colors text-center" data-id="element-201">
                  {language === 'es' ? 'Agenda tu cita' : 'Book your appointment'}
                </a>
              </div>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
};